<template>
  <section class="quick-quote-info">
    <div class="table">
      <div class="tr th">
        <span>Item</span>
        <span>Information</span>
      </div>
      <div class="tr">
        <span>Total Contract Sum</span>
        <span>{{ quoteForm.tol_contr_sum }}</span>
      </div>
      <!--      <div class="tr">-->
      <!--        <span>Material Damage Coverage</span>-->
      <!--        <span>{{ getOptionName('yesNoOptions', quoteForm.mat_dam_cvr_ind) }}</span>-->
      <!--      </div>-->
      <div class="tr">
        <span>Third Party Liability Limit</span>
        <span>{{ getAllOptionName24('limit_of_liability', quoteForm.tppd_limit_amt) }}</span>
      </div>
      <div class="tr">
        <span>Outdoor Work</span>
        <span>{{ getOptionName('yesNoOptions', quoteForm.outdoor_wk_ind) }}</span>
      </div>
    </div>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
export default {
  name: 'DecorationQuickQuoteInfo',
  mixins: [MixinOptions, MixinFormat],
  props: {
    quoteForm: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
            
    }
  }
}
</script>
<style lang="scss" scoped>
.quick-quote-info {
    display: flex;
    justify-content: space-between;
    .table {
        width: calc(50% - 10px);
    }
}
</style>